import { loadStripe } from '@stripe/stripe-js';

export const getStripe = async () => {
  // Vite injectează automat valoarea aici. Nu scrie manual import.meta.env = ...
  const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

  if (!key) {
    console.error("❌ Eroare: Cheia Stripe lipsește din mediul de execuție.");
    return null;
  }

  // Folosim trim() pentru a elimina eventuale spații invizibile din .env
  return await loadStripe(key.trim());
};